export var months = [
    { name: 'Январь', value: 1 },
    { name: 'Февраль', value: 2 },
    { name: 'Март', value: 3 },
    { name: 'Апрель', value: 4 },
    { name: 'Май', value: 5 },
    { name: 'Июнь', value: 6 },
    { name: 'Июль', value: 7 },
    { name: 'Август', value: 8 },
    { name: 'Сентябрь', value: 9 },
    { name: 'Октябрь', value: 10 },
    { name: 'Ноябрь', value: 11 },
    { name: 'Декабрь', value: 12 }
];
export var idToMonth = {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь'
};
export var idToMonthPassive = {
    1: 'январе',
    2: 'феврале',
    3: 'марте',
    4: 'апреле',
    5: 'мае',
    6: 'июне',
    7: 'июле',
    8: 'августе',
    9: 'сентябре',
    10: 'октябре',
    11: 'ноябре',
    12: 'декабре'
};
export var idToMonthGenitive = {
    1: 'января',
    2: 'февраля',
    3: 'марта',
    4: 'апреля',
    5: 'мая',
    6: 'июня',
    7: 'июля',
    8: 'августа',
    9: 'сентября',
    10: 'октября',
    11: 'ноября',
    12: 'декабря'
};
